// ABOUTME: The registry every build without VITE_MOCK_API gets in place of ./registry (see vite.config.ts): nothing is
// ABOUTME: mocked and no flag is forced, and none of the mock code is imported, so it never reaches that bundle.
import type { MockRegistry } from './types';

export const mockRegistry: MockRegistry = { apis: {}, features: {} };
